var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnArrow24Outline = function SvgLightIcnArrow24Outline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00FFFA",
    fillRule: "evenodd",
    d: "M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18m0-1a8 8 0 1 0 0-16 8 8 0 0 0 0 16M9.743 8.622a.5.5 0 0 0 .07.704l3.268 2.682-3.268 2.665a.5.5 0 0 0 .633.775l3.74-3.052a.5.5 0 0 0 .002-.774l-3.741-3.07a.5.5 0 0 0-.704.07",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnArrow24Outline;